import { render, staticRenderFns } from "./AssignAccessToCompanyUserDialog.vue?vue&type=template&id=49f1f986&"
import script from "./AssignAccessToCompanyUserDialog.vue?vue&type=script&lang=ts&"
export * from "./AssignAccessToCompanyUserDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports